export interface VideoFileMetadata {
  duration?: number;
  ratio?: number;
}

/**
 * Reads duration and aspect ratio (height / width) from a video file.
 * Resolves with an empty object if the metadata cannot be read, so callers
 * can await it without failing the upload flow.
 */
export const loadVideoMetadata = (file: File): Promise<VideoFileMetadata> =>
  new Promise((resolve) => {
    const video = document.createElement('video');
    video.preload = 'metadata';

    video.onloadedmetadata = () => {
      window.URL.revokeObjectURL(video.src);
      resolve({
        duration: video.duration,
        ratio: video.videoWidth ? video.videoHeight / video.videoWidth : undefined,
      });
    };
    video.onerror = () => {
      window.URL.revokeObjectURL(video.src);
      resolve({});
    };

    video.src = URL.createObjectURL(file);
  });
